/**
 * Money crosses the wire as integer USD cents and is shown in dollars.
 *
 * Kept in one place so a rounding rule is never reinvented per screen: the API
 * rejects floating-point dollars outright.
 */

/** 1999 → "19.99". Always two decimals, so an input does not jump about. */
export const centsToInput = (cents: number) => (cents / 100).toFixed(2);

/**
 * Re-exported so admin keeps one import for money, but the rule itself lives in
 * `@mds/shared/lib/format` — the public site prices the same booking.
 */
export { formatCents } from '@mds/shared/lib/format';

/**
 * "19.99" → 1999, or null when it is not a usable amount.
 *
 * Rounds to the nearest cent rather than truncating, and refuses negatives —
 * the API caps at 0 and 1,000,000,000 cents.
 */
export function inputToCents(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === '') return null;
  const amount = Number(trimmed);
  if (!Number.isFinite(amount) || amount < 0) return null;
  const cents = Math.round(amount * 100);
  return cents > 1_000_000_000 ? null : cents;
}
